import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { useSelector } from "react-redux";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import CountUp from "react-countup";
import { achievements } from "../constants/constants";
import { useTranslation } from "react-i18next";

const OurAchievements = () => {
  const { t, i18n } = useTranslation();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative">
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        <MainTitle title={t("Our Achievements")} />

        {/* Our Achievements section  */}
        <section className="mainContainer w-full px-[20px] lg:px-0">
          <div className="my-[120px] w-full grid grid-cols-1 lg:grid-cols-2 gap-[80px]">
            {/* card */}
            {achievements?.map((card: any) => {
              return (
                <div
                  data-aos="fade-up"
                  data-aos-duration="900"
                  className="col-span-1 h-[203px] p-[20px] bg-white rounded-[20px] shadow-shadow_main flex items-center gap-[20px]"
                >
                  <div className="w-[248px] rounded-[20px]">
                    <img src={card.image} alt="" />
                  </div>

                  <div>
                    <p
                      className={`font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[16px] text-second_color`}
                    >
                      {i18n.language === "en"
                        ? `${card.title}`
                        : `${card.titleArabic}`}
                    </p>
                    <p
                      className={`font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[400] text-[14px] text-[#444444]`}
                    >
                      {card.year ? `${t("Since")}` + `${" "}` + card.year : ""}
                    </p>
                    <p
                      className={`font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[32px] text-first_color`}
                    >
                      <CountUp start={0} end={card.count} duration={3} />
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default OurAchievements;
